import template from "./index.html";
import "../node_modules/font-awesome/less/font-awesome.less";
import "./styles/main.scss";


let appComponent = {
  template,
  restrict: 'E'
};

export default appComponent;



// WEBPACK FOOTER //
// ./app/app.component.js